import React from 'react';
import clsx from 'clsx';

import { Skeleton } from '../components';
import { useJessica } from '../../../hooks';
import { PageLayout } from '../../../app/Layouts';
import type { LessonType } from '../useCourse';
import type { TabsProps } from '../../../components';

export type LayoutProps = {
  quiz: React.ReactNode;
  title: React.ReactNode;
  video: React.ReactNode;
  navigation: React.ReactNode;
  nextButton?: React.ReactNode;
  breadcrumbs: React.ReactNode;
  progressBar: React.ReactNode;

  tabs: React.ReactElement<TabsProps>;
  jessica: React.ReactElement<{ className?: string; callbacks: any }> | false;

  loading: boolean;
  stepDetails: LessonType | null;
};

export const DesktopLayout: React.FC<LayoutProps> = ({
  title,
  tabs,
  quiz,
  video,
  jessica,
  navigation,
  breadcrumbs,
  progressBar,

  loading,
  stepDetails,
}) => {
  const { type, callbacks } = useJessica();

  return (
    <PageLayout
      subheaderContent={
        <div className="border-b w-full">
          <div className="m-5 flex flex-row justify-between items-center">
            {breadcrumbs}
            <div className="w-[24rem]">{progressBar}</div>
          </div>
        </div>
      }
    >
      <>
        {navigation}

        <div className="flex flex-row h-full overflow-y-scroll w-full">
          {loading ? (
            <Skeleton />
          ) : (
            <div className="px-lg flex justify-center w-full">
              <div className="max-w-[88rem] w-full flex flex-col ">
                {title}
                {stepDetails?.type !== 'QUIZ' ? (
                  <>
                    {video}
                    {tabs}
                  </>
                ) : (
                  quiz
                )}
              </div>
            </div>
          )}

          {jessica &&
            React.cloneElement(jessica, {
              callbacks,
              className: clsx(
                type === 'transcribe'
                  ? 'static-jessica-on-page max-w-[32rem] min-w-[32rem]'
                  : '',
                'h-full',
                'shrink-0 mr-xl'
              ),
            })}
        </div>
      </>
    </PageLayout>
  );
};
